import Vue from "vue";

import RewardsGreetingNoTicket from "./RewardsGreetingNoTicket.vue";

export function load() {
    const selector = "rewards-greeting-no-ticket";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(RewardsGreetingNoTicket, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
